// src/Results.js
import React from 'react';

function Results({ score, totalQuestions, onRetry }) {
  return (
    <div className="results-container">
      <h2>Quiz Complete!</h2>
      <p>You scored {score} out of {totalQuestions}</p>
      <button onClick={onRetry}>Try Again</button>
    </div>
  );
}

export default Results;